'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useAuth } from '@/contexts/AuthContext';

interface PublicNavProps {
  /** Show the Pricing link on the right side (used on the landing page) */
  showPricingLink?: boolean;
}

export default function PublicNav({ showPricingLink = false }: PublicNavProps) {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Left: logo + My Collections */}
        <div className="flex items-center gap-3">
          <Link href="/" className="flex items-center gap-2.5">
            <Image
              src="/assets/images/logo_v2.2_blue-1784210789861.png"
              alt="CoLoco logo"
              width={32}
              height={32}
              className="rounded-lg flex-shrink-0"
              priority
            />
            <span className="text-lg font-bold text-gray-900 tracking-tight">CoLoco</span>
          </Link>
          {user && (
            <Link
              href={isMobile ? '/get-the-app' : '/collections'}
              className="hidden sm:inline-flex bg-primary hover:bg-primary-dark text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors duration-150 shadow-sm"
            >
              My Collections
            </Link>
          )}
        </div>

        {/* Right: optional Pricing + Account/Sign In */}
        <div className="flex items-center gap-3">
          {showPricingLink && (
            <Link
              href="/pricing"
              className="bg-primary hover:bg-primary-dark text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors duration-150 shadow-sm"
            >
              Pricing
            </Link>
          )}
          {user ? (
            <Link
              href="/account"
              className="bg-primary hover:bg-primary-dark text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors duration-150 shadow-sm"
            >
              Account
            </Link>
          ) : (
            <Link
              href="/login"
              className="bg-primary hover:bg-primary-dark text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors duration-150 shadow-sm"
            >
              Sign In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
